import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-contenedor-caido-loading',
  templateUrl: './contenedor-caido-loading.component.html',
  styleUrls: ['./contenedor-caido-loading.component.css']
})
export class ContenedorCaidoLoadingComponent implements OnInit {

  gif: AnimationOptions = {
    path: '/assets/animaciones/conexion.json'
  };
  ancho: String = '';
  altura: String = '';
  constructor( private ref: DynamicDialogRef,) { }

  ngOnInit() {
    const iniciar = window.innerWidth;
    this.guardarTamaño(iniciar);
  }

  guardarTamaño(size: number) {
    if (size <= 767) {
      this.ancho = '35px';
      this.altura = '35px';
    } else if (size <= 992) {
      this.ancho = '48px';
      this.altura = '48px';
    } else if (size >= 992) {
      this.ancho = '48px';
      this.altura = '48px';
    }
  }

  cerrar() {
    this.ref.close()
  }

}
